 <template>
   <div class="main-container" style="height: 100%">
    <div v-if="!this.$parent.isDesktop" class="pause_video" @click="pasuedVideo"></div> 
    <div class="video-player" @click="loadVideo" style="height: 100%;width: 100%;">
      <!-- controls -->
      <button class="video-player__controls" v-if="videoState==='paused'">
        <img data-src="https://prod-img.thesouledstore.com/static/media/play.png" alt="Media Play">
      </button>

      <button class="video-player__controls" v-if="videoState==='loading'">
        <img data-src="https://prod-img.thesouledstore.com/static/media/play.png" alt="Media Play">
      </button>
      <!-- <div class="loader video-player__controls" v-if="videoState==='loading'">
      </div>-->
      
      <button @click="muteVideo($event, false)" class="video-player__controls muted" v-if="muted && videoState==='play'">
        <img v-if="playNewDesign" :src="'https://prod-img.thesouledstore.com/static/mute-icon.png'" alt="Media Mute">
        <img v-else data-src="https://prod-img.thesouledstore.com/static/media/mute.png" alt="Media Mute">
      </button>
      <button @click="muteVideo($event, true)" class="video-player__controls sound" v-if="!muted && videoState==='play'">
        <img v-if="playNewDesign" :src="'https://prod-img.thesouledstore.com/static/sound-icon.png'" alt="Media Sound">
        <img v-else data-src="https://prod-img.thesouledstore.com/static/media/sound.png" alt="Media Sound">
      </button>
       <!-- workaround for fixing issue android -->
      <div v-if="videoPlayback" @click="loadVideo" style="position:absolute; width: 100%; height:100%; z-index: 1" ></div>
      <video crossorigin="" style="height: 100%;width: 100%;object-fit: cover;" @playing="checkVideoStatus" class="video-js" ref="video" :poster="posterImg" muted autoplay loop playsinline>
        <source :src="src" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')
window.jQuery = $
import Loader from '../common/loader.vue'
var Hls = () => import('hls.js')

export default {
  name: 'VideoPlayer',
  props: {
    src: String,
    poster: String,
    playVideo: Boolean,
    isVideo: Boolean,
    playNewDesign: String,
    type: String
  },
  components: {Loader},
  data () {
    return {
      videoPlayback: true,
      videoState: 'loading', // paused, play, loading
      muted: true,
      prdImg: process.env.IMG_BASE_URL + process.env.PRODUCT_DETAIL_IMG,
      preview: false,
      carouselArray: []
    }
  },
  computed: {
    videoElement () {
      return this.$refs.video
    },
    posterImg () {
      if (this.type && this.type === 'care_page') {
        return this.poster
      } else {
        return this.prdImg + this.poster
      }
    }
  },
  methods: {
    previewArrayForVideo: function () {
      const newUrl = this.src + '@|viedeo|@' + this.imgArr[this.activeIndex]
      this.carouselArray = [newUrl]
      this.preview = true
    },
    pasuedVideo: function () {
      this.videoState = 'paused'
      const video = this.videoElement
      video.pause()
    },
    loadVideo: function () {
      Hls().then(Hls => {
        const video = this.videoElement
        video.muted = this.muted
       // video.muted = true
        if (video.paused) {
          video.play()
          this.videoState = 'play'
        } else {
          video.pause()
          this.videoState = 'paused'
        }
        if (this.videoPlayback) {
          this.videoPlayback = false
          if (Hls.isSupported()) {
            var hls = new Hls()
            hls.loadSource(this.$props.src)
            hls.attachMedia(video)
            hls.on(Hls.Events.MANIFEST_PARSED, function () {
              video.play()
            })
          } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = this.$props.src
            video.addEventListener('loadedmetadata', function () {
              video.play()
            })
          }
        }
      })
    },
    muteVideo: function (event, isMute) {
      event.stopPropagation()
      // mute video
      this.videoElement.muted = isMute
      // change muted vue state
      isMute ? this.muted = true : this.muted = false
    },

    checkVideoStatus: function (e) {
      if (e.target.readyState === 4) {
        this.videoState = 'play'
      }
    }
  },
  created: function () {
    Hls().then(Hls => {
      if (this.playVideo) {
        $('.video-player').trigger('click')
        $('.video-player__controls').trigger('click')
      }
      if (!this.playVideo || this.playNewDesign === 'stopAutoplay') {
        const video = this.videoElement
        video.loop = false
        video.addEventListener('ended', () => {
          video.currentTime = 0
          this.videoState = 'paused'
        })
      }
      if (this.playNewDesign) {
        const video = this.videoElement
        video.poster = ''
      }
      if (this.playNewDesign === 'stopAutoplay') {
        setTimeout(() => {
          this.pasuedVideo()
        }, 500)
      }
    })
  },
  mounted () {
    if (!this.playVideo) {
      this.pasuedVideo()
    }
  },
  watch: {
    // listener for playVideo prop to change
    playVideo: function (newVal) {
      if (newVal) {
        // this.loadVideo()
        this.videoState = 'play'
      } else {
        this.videoElement.pause()
        this.videoState = 'paused'
      }
    }
  }
}
</script>

<style scoped>

  .video-player {
    position: relative;
    width: 100%
  }

  .video-player video {
    display: block;
    width: 100%;
  }

  .video-player__controls {
    position: absolute;
    transform: translate(-50%,-50%);
    left: 50%;
    top: 50%;
    border: none;
    background: transparent;
    cursor: pointer;
    z-index: 100;
  }

  .video-player__controls img {
    width: 50px;
  }

  .video-player__controls.muted,
  .video-player__controls.sound {
    bottom: 10px;
    left: 10px;
    top: unset;
    width: 50px;
    transform: translate(0px, 0px);
    outline: none;
  }
  .activewear-landing .video-player__controls.muted, .activewear-landing .video-player__controls.sound{
    display: none;
  }

  .video-player.pause {
    position: absolute;
    top: 1rem;
    bottom: 1rem;
  }

  .loader, .loader:after {
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
  }
  .loader {
    margin: -10px 0 0 -10px;
    font-size: 10px;
    position: absolute;
    text-indent: -9999em;
    border-top: 4px solid rgba(255, 255, 255, 0.2);
    border-right: 4px solid rgba(255, 255, 255, 0.2);
    border-bottom: 4px solid rgba(255, 255, 255, 0.2);
    border-left: 4px solid #ffffff;
    transform: translateZ(0);
    animation: load8 1.1s infinite linear;
  }

  @keyframes load8 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @media screen and (max-width: 768px) {
    .activewear-landing .video-player__controls img {
      width: 23px;
    }
    .main-container{
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// VideoPlayer.vue?c5c6bdaa